module.exports = __webpack_public_path__ + "static/media/script.59ad0ff9.svg";